import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorsStackService} from '@services/errors-stack.service';
import {ErrorLoggerService} from '@services/error-logger.service';
import {environment} from '@environments/environment';
import {EventsService} from '@services/events.service';
import {NotyPosition} from '@components/noty/noty.enums';

/**
 * Глобальный перехватчик ошибок Runtime
 */

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(
        private injector: Injector,
    ) {

    }

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            return;
        }

        /**
         * Перехватчик инициализируется до сервисов, поэтому DI приходится делать через inject
         * @type {Router}
         */
        const router = this.injector.get(Router);
        const errorsService = this.injector.get(ErrorsStackService);

        /**
         * Логируем ошибки
         * @type {ErrorLoggerService}
         */
        const errorLogger = this.injector.get(ErrorLoggerService);
        errorLogger.log(error);

        console.error(error);
        /**
         * Передаем информацию об ошибке на страницу /error через сервис
         */
        errorsService.errors$.next(error);

        /**
         * Для Production показываем страницу /error, а в деве просто всплывашку с ошибкой
         */
        if (environment.production) {
            router.navigate(['/error']);
        } else {
            const eventsService = this.injector.get(EventsService);
            eventsService.showNoty({
                type: 'error',
                position: NotyPosition.bottomCenter,
                content: `<p>Произошла ошибка во время выполнения кода. Смотри консоль для подробностей и напиши об этом Bug Report</p>
                            <small>Это уведомление доступно только для develop окружения,
                            в production вместо него был бы редирект на страницу ошибки</small>`,
                timeout: 30000,
                hideOnRouteChange: false,
            });
        }
    }
}
